import React, { useEffect, useRef } from 'react'
import { Id, toast } from 'react-toastify'

const TechnicalPauseAlertToast = () => {
    const title = __GLOBAL__?.VITE_TECHNICAL_PAUSE_TITLE ?? 'Ведутся технические работы'
    const message =
        __GLOBAL__?.VITE_TECHNICAL_PAUSE_MESSAGE ??
        'Совсем скоро всё заработает. Спасибо за терпение'

    return (
        <section>
            <strong>{title}</strong>
            <div>{message}</div>
        </section>
    )
}

export function TechnicalPauseAlert() {
    const toastIdRef = useRef<Id | undefined>()

    /**
     * Показываем toast, если интернет пропал
     */
    useEffect(() => {
        if (__GLOBAL__?.VITE_TECHNICAL_PAUSE_ENABLED === 'true') {
            toastIdRef.current = toast.warn(<TechnicalPauseAlertToast />, {
                isLoading: true,
                closeOnClick: false,
                closeButton: true,
            })
        }
    }, [])

    return null
}
